import { SORT_DIRECTION__DESC } from 'react-redux-app/lib/modules/table/constants';
import {
  PAYOUT_REQUESTS_GRID_NAME,
  PAYOUT_STATUS__PENDING,
  PAYOUT_STATUS__APPROVED,
} from '../constants';

import { defaultFilter as defaultFilterBase } from '../../queryFilter/constants';

import { getGridFilterByName } from '../../queryFilter/utils/gridFilter';


export const getDefaultFilter = () => ({
  ...defaultFilterBase,
  sortField: 'requestDate',
  sortDirection: SORT_DIRECTION__DESC,
  status: [PAYOUT_STATUS__PENDING, PAYOUT_STATUS__APPROVED],
});

export const getGridFilter = location => (
  getGridFilterByName(location, PAYOUT_REQUESTS_GRID_NAME, getDefaultFilter())
);
